/**
 * Slide media box: height and aspect-ratio must not be applied together.
 * An explicit height wins (dashboard help already documents this).
 */
export function carouselSlideCardMediaStyles(
  height?: string | null,
  aspectRatio?: string | number | null,
): { aspectRatio: string | null; height: string | null } {
  const trimmedHeight = typeof height === 'string' ? height.trim() : '';
  if (trimmedHeight) {
    return { aspectRatio: null, height: `${trimmedHeight}px` };
  }

  if (aspectRatio === null || aspectRatio === undefined || aspectRatio === '') {
    return { aspectRatio: null, height: null };
  }

  return { aspectRatio: String(aspectRatio), height: null };
}
